<template>
    <v-card-text class="px-6 py-4">
        <v-row>
            <v-col class="text-center pa-0" v-if="!showCarousel">
                <v-img
                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/pay-attention.jpg"
                    class="mx-auto mb-3"
                    height="250"
                    max-width="250"
                />
                <p class="subtitle-1 font-weight-bold">
                    Ensure you read the next set of instructions carefully
                </p>

                <v-row>
                    <v-col class="text-left">
                        <v-btn
                            class="text-capitalize"
                            text
                            large
                            @click="showCarousel = true, currentSlide = totalSlides - 1"
                        >
                            Skip
                        </v-btn>
                    </v-col>

                    <v-col class="text-right">
                        <v-btn
                            class="text-capitalize px-10 rounded-lg"
                            color="primary"
                            dark
                            depressed
                            large
                            @click.native="showCarousel = true"
                        >
                            Continue
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-else class="py-0" :class="[{ 'px-0': $vuetify.breakpoint.smAndDown }]">
                <v-carousel
                    v-model="currentSlide"
                    :show-arrows="false"
                    height="350"
                >
                    <template v-if="!showP2PSteps">
                        <v-carousel-item>
                            <div>
                                <div class="text-center">
                                    <v-img
                                        :src="posterAvatar"
                                        height="100"
                                        max-width="100"
                                        class="mb-3 mx-auto"
                                    />
                                    <p class="subtitle-1 mb-0 text-uppercase font-weight-bold">
                                        {{ recipientName }} gets
                                    </p>
                                    <p class="headline font-weight-bold mb-0">
                                        {{ subtotalInPbCurrency }}
                                        <span class="subtitle-2 font-weight-regular teal--text lighten-1">
                                            {{ order.type !== 'hybrid' ? order.matcher_currency : order.pb_currency }}
                                        </span>
                                    </p>
                                </div>

                                <div class="d-flex mt-3 mt-lg-8">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p>
                                        Note that only complete payments will be accepted.
                                        Incomplete payments wll not be acknowledged as received and are unacceptable
                                    </p>
                                </div>
                            </div>
                        </v-carousel-item>

                        <v-carousel-item>
                            <div>
                                <v-img
                                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/payment-methods.jpg"
                                    height="150"
                                    max-width="300"
                                    class="mb-3 mx-auto"
                                />

                                <div class="d-flex mt-3 mt-lg-8">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p>
                                        Kindly ensure you make payment from the <span class="red--text">EXACT BANK ACCOUNT</span>,
                                        (not just the bank) which you registered on Kaoshi under payment method, under settings.
                                    </p>
                                </div>
                            </div>
                        </v-carousel-item>

                        <v-carousel-item>
                            <div>
                                <v-img
                                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/payment-methods.jpg"
                                    height="150"
                                    max-width="300"
                                    class="mb-3 mx-auto"
                                />

                                <div class="d-flex mt-3 mt-lg-8">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p>
                                        For <span class="red--text">DEBIT/CREDIT</span> card payment,
                                        ensure that the <span class="red--text">DEBIT/CREDIT</span> card
                                        debits from the <span class="red--text">EXACT BANK ACCOUNT</span> (not just the bank)
                                        which you registered on Kaoshi under payment method, under settings.
                                    </p>
                                </div>
                            </div>
                        </v-carousel-item>

                        <v-carousel-item>
                            <div>
                                <div class="text-center">
                                    <v-img
                                        :src="posterAvatar"
                                        height="100"
                                        max-width="100"
                                        class="mb-3 mx-auto"
                                    />
                                    <p class="subtitle-1 mb-0 text-uppercase font-weight-bold">
                                        {{ recipientName }} gets
                                    </p>
                                    <p class="headline font-weight-bold mb-0">
                                        {{ subtotalInPbCurrency }}
                                        <span class="subtitle-2 font-weight-regular teal--text lighten-1">
                                            {{ order.pb_currency }}
                                        </span>
                                    </p>
                                </div>

                                <div class="d-flex mt-3 mt-lg-6">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p>
                                        However, do not overpay as all overpayments are irreversible and unacceptable.
                                        Only pay the exact amount as shown below:
                                    </p>
                                </div>

                                <p
                                    class="font-weight-bold text-center mb-0 mt-n3"
                                    :class="[$vuetify.breakpoint.smAndDown ? 'subtitle-1' : 'title']"
                                >
                                    {{ order.type === 'hybrid' ? 'Make Sure Virtual Account Gets' : 'Total Amount Due' }}:
                                    {{ totalAmount }}
                                </p>
                            </div>
                        </v-carousel-item>
                    </template>
                    <template v-else>
                        <v-carousel-item>
                            <div>
                                <v-img
                                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/payment-methods.jpg"
                                    height="150"
                                    max-width="300"
                                    class="mb-3 mx-auto"
                                />

                                <div class="d-flex mt-3 mt-lg-8">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p class="subtitle-1">
                                        Make sure you select the bank and specific bank account you registered under payment
                                    </p>
                                </div>
                            </div>
                        </v-carousel-item>

                        <v-carousel-item>
                            <div>
                                <v-img
                                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/chase-login.jpg"
                                    height="150"
                                    max-width="300"
                                    class="mb-3 mx-auto"
                                />

                                <div class="d-flex mt-3 mt-lg-8">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p class="subtitle-1">
                                        You will be redirected to your selected bank’s online login page.
                                        <span class="font-weight-bold">(Example: Chase Bank)</span>
                                    </p>
                                </div>
                            </div>
                        </v-carousel-item>

                        <v-carousel-item>
                            <div>
                                <v-img
                                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/chase-dashboard.jpg"
                                    height="150"
                                    max-width="300"
                                    class="mb-3 mx-auto"
                                />

                                <div class="d-flex mt-3 mt-lg-8">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p class="subtitle-1">Select “Pay bills & Quickpay with {{ deliveryMethod }}”</p>
                                </div>
                            </div>
                        </v-carousel-item>

                        <v-carousel-item>
                            <div>
                                <div class="text-center">
                                    <v-img
                                        :src="posterAvatar"
                                        height="100"
                                        max-width="100"
                                        class="mb-3 mx-auto"
                                    />
                                    <p class="subtitle-1 mb-0 text-uppercase font-weight-bold">
                                        {{ recipientName }} gets
                                    </p>
                                    <p class="headline font-weight-bold mb-0">
                                        {{ formatAmount(order.pb_amount) }}
                                        <span class="subtitle-2 font-weight-regular teal--text lighten-1">
                                            {{ order.matcher_currency }}
                                        </span>
                                    </p>
                                </div>

                                <div class="d-flex mt-3 mt-lg-8">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p class="subtitle-1">
                                        Pay <span class="font-weight-bold green--text lighten-1">
                                            {{ totalAmount }}
                                        </span> to <span class="orange--text darken-2 font-weight-bold">{{ postersBeneficiary.email }}</span>
                                        with your {{ deliveryMethod }}
                                    </p>
                                </div>
                            </div>
                        </v-carousel-item>

                        <v-carousel-item>
                            <div>
                                <v-img
                                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/transaction.jpg"
                                    height="150"
                                    max-width="300"
                                    class="mb-3 mx-auto"
                                />

                                <div class="d-flex mt-3 mt-lg-8">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p class="subtitle-1">
                                        <span class="orange--text darken-2">VERY IMPORTANT:</span>
                                        Ensure the payment is successful and the money has been debited from your account.
                                    </p>
                                </div>
                            </div>
                        </v-carousel-item>

                        <v-carousel-item>
                            <div>
                                <v-img
                                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/call-center.jpg"
                                    :height="$vuetify.breakpoint.mdAndUp ? 200 : 150"
                                    :max-width="$vuetify.breakpoint.mdAndUp ? 250 : 200"
                                    class="mb-3 mx-auto"
                                />

                                <div class="d-flex mt-3">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p class="subtitle-2">
                                        Sometimes <span class="font-weight-bold">{{ deliveryMethod }}</span>
                                        transactions take longer to process and may require you to call your
                                        bank to ensure that your transactions are processed in a timely manner
                                        to meet the 2 hour countdown for this transaction.
                                    </p>
                                </div>
                            </div>
                        </v-carousel-item>

                        <v-carousel-item>
                            <div>
                                <v-img
                                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/call-center.jpg"
                                    height="200"
                                    max-width="250"
                                    class="mb-3 mx-auto"
                                />

                                <div class="d-flex mt-3 mt-lg-8">
                                    <v-icon class="mr-5 mt-n5" color="green">mdi-check-circle-outline</v-icon>
                                    <p class="subtitle-1">
                                        Upon confirmation of a successful transaction return back to Kaoshi and click the
                                        <span class="font-weight-bold">“Paid”</span> button
                                    </p>
                                </div>
                            </div>
                        </v-carousel-item>
                    </template>
                </v-carousel>

                <v-row class="mt-5 mt-lg-0">
                    <v-col
                        class="col-lg-6"
                        :class="[!!currentSlide ? 'text-center text-md-left col-4': 'text-left']"
                    >
                        <v-btn
                            class="text-capitalize"
                            text
                            large
                            v-if="currentSlide !== totalSlides-1"
                            @click="currentSlide = totalSlides - 1"
                        >
                            Skip
                        </v-btn>
                    </v-col>

                    <v-col
                        class="d-flex justify-md-end col-lg-6"
                        :class="[!!currentSlide ? 'justify-center' : 'justify-end']"
                    >
                        <v-btn
                            class="text-capitalize px-5 rounded-lg mr-3"
                            color="amber"
                            text
                            large
                            v-if="currentSlide > 0"
                            @click="currentSlide--"
                        >
                            Prev
                        </v-btn>
                        <v-btn
                            class="text-capitalize px-5 rounded-lg"
                            color="primary"
                            dark
                            depressed
                            large
                            @click.prevent="currentSlide++"
                            v-if="currentSlide < totalSlides-1"
                        >
                            Next
                        </v-btn>
                        <v-btn
                            v-else
                            class="text-capitalize px-5 rounded-lg"
                            color="primary"
                            dark
                            depressed
                            large
                            @click="$emit('proceed')"
                        >
                            Proceed
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card-text>
</template>

<script>
let currency = require('../../../modules/currency.js');

export default {
    data() {
        return {
            showCarousel: false,
            currentSlide: 0,
        }
    },
    mounted() {
        if(this.showP2PSteps) {
            this.showCarousel = false;
        }
    },
    props: {
        order: {
            type: Object,
            required: true,
        },
        postersBeneficiary: {
            type: Object,
            required: true,
        },
        showP2PSteps: {
            type: Boolean,
            default: false,
        },
        totalSlides: {
            type: Number,
            required: true,
        },
    },
    computed: {
        recipientName() {
            if (this.order.type === 'hybrid') {
                return this.$_user.firstname;
            }
            return this.posterFirstName;
        },
        posterFirstName() {
            const name = this.postersBeneficiary.full_name || this.postersBeneficiary.name;
            const [first_name] = name.split(' ');
            return first_name;
        },
        posterAvatar() {
            return this.postersBeneficiary.avatar || 'https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/user.png'
        },
        subtotalInPbCurrency() {
            const amount = parseFloat(this.order.pb_amount) + parseFloat(this.order.matcher_fee);
            return this.formatAmount(amount);
        },
        totalAmount() {
            const amount = this.order.matcher_fee + this.order.pb_amount;
            return `${currency.getCurrencySymbol(this.order.pb_currency)}${amount.toFixed(2)}`
        },
        deliveryMethod() {
            return this.postersBeneficiary.method.toUpperCase()
        },
    },
}
</script>

<style scoped>
.v-carousel >>> .v-carousel__controls {
    position: absolute;
    bottom: -5px;
}

.v-carousel >>> .v-carousel__controls__item.v-btn.v-item--active::before,
.v-carousel >>> .v-carousel__controls {
    background-color: transparent;
}
.v-carousel >>> .v-carousel__controls__item .v-icon {
    opacity: 1;
}
/* v-item--activev-btn--active.v-btn--icon */
.v-carousel >>> .v-carousel__controls__item.v-btn {
    color: #c4c4c4;
}

.v-carousel >>> .v-carousel__controls__item.v-btn.v-item--active {
    color: #5DAE6F;
}

@media screen and (max-width: 767px) {
    .v-carousel >>> .v-carousel__controls {
        bottom: -15px;
    }
}
</style>
